import React from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";
import requiredFieldValidator from "../validations/requiredField";
import emailValidator from "../validations/email";
import renderErrors from "../validations/renderErrors";

const LoginForm = ({
  checkButton,
  closeModal,
  email,
  errors,
  form,
  handleSubmit,
  onChangeEmail,
  onChangePassword,
  password,
  setErrors,
}) => (
  <>
    <button className="close-btn" onClick={closeModal}>
      X
    </button>
    <h2>Log In</h2>
    <Form
      onChange={() => {
        setErrors({});
      }}
      onSubmit={handleSubmit}
      ref={form}
    >
      <div className="api-error">{errors && renderErrors(errors)}</div>
      <div className="input-container" id="input-container">
        <Input
          type="email"
          name="email"
          placeholder="email"
          className="input-field"
          value={email}
          onChange={onChangeEmail}
          ref={form}
          validations={[requiredFieldValidator, emailValidator]}
        />
      </div>
      <div className="input-container">
        <Input
          type="password"
          name="password"
          placeholder="password"
          className="input-field"
          value={password}
          onChange={onChangePassword}
          ref={form}
          validations={[requiredFieldValidator]}
        />
      </div>
      <div>
        <button className="auth-btn">Log In</button>
        <Button style={{ display: "none" }} ref={checkButton} />
      </div>
    </Form>
  </>
);

export default LoginForm;
